import MainPageCommonService from "../../services/main-page/MainPageCommonService";
import MainPageDesktop from "./MainPageDesktop";
import MainPageMobile from "./MainPageMobile";

export default class MainPage extends MainPageCommonService {
    constructor($holder: JQuery) {
        super();

        this.init($holder);
    }

    /**
     * Инициализация страницы
     * @private
     */
    private init($holder: JQuery): void {
        const isMobileDeviceDetected = this.detectMobileDevice();

        if (isMobileDeviceDetected) {
            new MainPageMobile($holder);
        } else {
            new MainPageDesktop($holder);
        }
    }
}
